export const InquiryPreferredMethod = {
  Phone: 100000000,
  Email: 100000001,
} as const;
export type InquiryPreferredMethod = (typeof InquiryPreferredMethod)[keyof typeof InquiryPreferredMethod];
